import { useQuery } from '@tanstack/react-query'
import { attendeeApi } from '@/api/attendee'
import { CalendarDays, MapPin } from 'lucide-react'
import { useAttendeeDates } from '@/hooks/useDates'

function AttendanceBadge({ status }: { status: string }) {
  const map: Record<string, string> = {
    Present:     'bg-green-100 text-green-700',
    Absent:      'bg-red-100 text-red-700',
    Failed:      'bg-amber-100 text-amber-700',
    NotRecorded: 'bg-slate-100 text-slate-500',
  }
  return <span className={`text-xs rounded-full px-2 py-0.5 ${map[status] ?? 'bg-slate-100 text-slate-500'}`}>{status === 'NotRecorded' ? 'Upcoming' : status}</span>
}

export default function AttendeeOverviewPage() {
  const { formatDate } = useAttendeeDates()
  const fmtDate = (iso: string) => {
    return formatDate(iso, { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' })
  }
  const { data: bookings = [], isLoading } = useQuery({
    queryKey: ['attendee-bookings'],
    queryFn: () => attendeeApi.getBookings().then(r => r.data),
  })

  return (
    <div className="space-y-4">
      <h1 className="text-lg font-semibold text-slate-900">Your bookings</h1>
      {isLoading ? (
        <p className="text-sm text-slate-400">Loading…</p>
      ) : bookings.length === 0 ? (
        <p className="text-sm text-slate-400">No bookings found.</p>
      ) : (
        <div className="space-y-3">
          {bookings.map(b => (
            <div key={b.sessionId} className="bg-white border border-slate-200 rounded-xl p-4 flex items-start justify-between gap-4">
              <div className="space-y-1.5">
                <p className="font-medium text-slate-900">{b.courseName}</p>
                <p className="flex items-center gap-1.5 text-sm text-slate-500">
                  <CalendarDays size={14} className="text-slate-400" /> {fmtDate(b.startsAt)}
                </p>
                {b.venueName && (
                  <p className="flex items-center gap-1.5 text-sm text-slate-500">
                    <MapPin size={14} className="text-slate-400" /> {b.venueName}
                  </p>
                )}
              </div>
              <AttendanceBadge status={b.attendanceStatus} />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
